import request from "@/hooks/useRequest";

// 新增子账户

// {
//   email: '',
//   login_password: '',
//   email_code: '',
//   phone_code": ',
// }
export const addSubAccountApi = (params) => {
  return request("/web-wallet/api/v1/account/sub-user/add", {
    body: params,
  });
};

// 检查子账户的邮箱
// {email: ''}
export const checkSubAccountEmailApi = (params) => {
  return request("/web-wallet/api/v1/account/sub-user/email/check", {
    body: params,
  });
};

// 启用子账户
// {target_id}
export const activateSubAccountApi = (params) => {
  return request("/web-wallet/api/v1/account/sub-user/activate", {
    body: params,
  });
};

// 停用子账户
// {target_id}
export const deactivateSubAccountApi = (params) => {
  return request("/web-wallet/api/v1/account/sub-user/deactivate", {
    body: params,
  });
};

// 删除子账户
// {target_id}
export const deleteSubAccountApi = (params) => {
  return request("/web-wallet/api/v1/account/sub-user/delete", {
    body: params,
  });
};

// 子账户列表
export const getSubAccountListApi = () => {
  return request("/web-wallet/api/v1/account/sub-user/list");
};

// 获取子账号申请状态
export const getSubAccountInfoApi = () => {
  return request("/web-wallet/api/v1/account/sub-user/application");
};

// 申请创建子账号权限
export const getSubAccountCreatePermissionApi = (params) => {
  return request("/web-wallet/api/v1/account/sub-user/apply", {
    body: params,
  });
};

// 获取账户资产余额
// {
//   from_account_target_id,
//   to_account_target_id,
//   currency
// }
export const getSubAccountBalanceApi = (params) => {
  return request("/web-wallet/api/v1/transfer/account-transfer-asset", {
    body: params,
  });
};

// {
//   "request_id": "string",
//   "from_account_target_id": "string",
//   "to_account_target_id": "string",
//   "currency": "string",
//   "amount": "string"
// }
// 帐号划转
export const transferAccountBalanceApi = (params) => {
  return request("/web-wallet/api/v1/transfer/account-fund-transfer", {
    body: params,
  });
};
